"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceForecastInnerToJSON = exports.AudienceForecastInnerFromJSONTyped = exports.AudienceForecastInnerFromJSON = exports.instanceOfAudienceForecastInner = void 0;
var runtime_1 = require("../runtime");
var ForecastType_1 = require("./ForecastType");
var RecommendationResults_1 = require("./RecommendationResults");
/**
 * Check if a given object implements the AudienceForecastInner interface.
 */
function instanceOfAudienceForecastInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAudienceForecastInner = instanceOfAudienceForecastInner;
function AudienceForecastInnerFromJSON(json) {
    return AudienceForecastInnerFromJSONTyped(json, false);
}
exports.AudienceForecastInnerFromJSON = AudienceForecastInnerFromJSON;
function AudienceForecastInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'estimatedFrequencyMax': !(0, runtime_1.exists)(json, 'estimated_frequency_max') ? undefined : json['estimated_frequency_max'],
        'estimatedFrequencyMin': !(0, runtime_1.exists)(json, 'estimated_frequency_min') ? undefined : json['estimated_frequency_min'],
        'estimatedImpressionsMax': !(0, runtime_1.exists)(json, 'estimated_impressions_max') ? undefined : json['estimated_impressions_max'],
        'estimatedImpressionsMin': !(0, runtime_1.exists)(json, 'estimated_impressions_min') ? undefined : json['estimated_impressions_min'],
        'estimatedReachMax': !(0, runtime_1.exists)(json, 'estimated_reach_max') ? undefined : json['estimated_reach_max'],
        'estimatedReachMin': !(0, runtime_1.exists)(json, 'estimated_reach_min') ? undefined : json['estimated_reach_min'],
        'forecastType': !(0, runtime_1.exists)(json, 'forecast_type') ? undefined : (0, ForecastType_1.ForecastTypeFromJSON)(json['forecast_type']),
        'recommendationResults': !(0, runtime_1.exists)(json, 'recommendation_results') ? undefined : (0, RecommendationResults_1.RecommendationResultsFromJSON)(json['recommendation_results']),
        'projectedUniqueUsers': !(0, runtime_1.exists)(json, 'projected_unique_users') ? undefined : json['projected_unique_users'],
        'availableImpressions': !(0, runtime_1.exists)(json, 'available_impressions') ? undefined : json['available_impressions'],
        'bookedImpressions': !(0, runtime_1.exists)(json, 'booked_impressions') ? undefined : json['booked_impressions'],
        'totalCapacity': !(0, runtime_1.exists)(json, 'total_capacity') ? undefined : json['total_capacity'],
    };
}
exports.AudienceForecastInnerFromJSONTyped = AudienceForecastInnerFromJSONTyped;
function AudienceForecastInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'estimated_frequency_max': value.estimatedFrequencyMax,
        'estimated_frequency_min': value.estimatedFrequencyMin,
        'estimated_impressions_max': value.estimatedImpressionsMax,
        'estimated_impressions_min': value.estimatedImpressionsMin,
        'estimated_reach_max': value.estimatedReachMax,
        'estimated_reach_min': value.estimatedReachMin,
        'forecast_type': (0, ForecastType_1.ForecastTypeToJSON)(value.forecastType),
        'recommendation_results': (0, RecommendationResults_1.RecommendationResultsToJSON)(value.recommendationResults),
        'projected_unique_users': value.projectedUniqueUsers,
        'available_impressions': value.availableImpressions,
        'booked_impressions': value.bookedImpressions,
        'total_capacity': value.totalCapacity,
    };
}
exports.AudienceForecastInnerToJSON = AudienceForecastInnerToJSON;
